import request from '@/utils/request';
const baseFinanceURL = process.env.VUE_APP_FINANCE;

/**
 * 顶部菜单栏查看SOP流程
 * /sop/getByMenu/{menuId}
 * /sop/documentDetail/{sopId}
 * /sop/document/version/detail
 */
/**
* SOP -菜单栏——查询流程第一步
 */
export const sopMenuPage = (data) => {
  return request({
    url: `/sop/getByMenu/${data}`,
    method: 'POST',
    baseURL: baseFinanceURL
  });
};
/**
 * SOP -菜单栏——查询流程第二步
 */
export const documentDetail = (data) => {
  return request({
    url: `/sop/documentDetail/${data}`,
    method: 'POST',
    baseURL: baseFinanceURL
  });
};

/**
 * SOP -分页
 */
export const sopPage = (data) => {
  return request({
    url: '/sop/page',
    method: 'POST',
    data,
    baseURL: baseFinanceURL
  });
};

/**
 * SOP -详情
 */
export const sopDetail = (data) => {
  return request({
    url: `/sop/detail/${data}`,
    method: 'POST',
    baseURL: baseFinanceURL
  });
};

/**
 * SOP -分页——累计
 */
export const sopTotalCount = (data) => {
  return request({
    url: `/sop/document/accessCount`,
    method: 'POST',
    data,
    baseURL: baseFinanceURL
  });
};

/**
 * SOP -分页——下载文件
 */
export const sopDownloadFile = (data) => {
  return request({
    url: `/sop/detail/${data}`,
    method: 'POST',
    data,
    baseURL: baseFinanceURL
  });
};

/**
 * SOP -分页——启用禁用
 */
export const sopStatus = (data) => {
  return request({
    url: `/sop/changeStatus`,
    method: 'POST',
    data,
    baseURL: baseFinanceURL
  });
};

/**
 * SOP -新增
 */
export const sopSave = (data) => {
  return request({
    url: `/sop/save`,
    method: 'POST',
    data,
    baseURL: baseFinanceURL
  });
};

/**
 * SOP -编辑
 */
export const sopUpdate = (data) => {
  return request({
    url: `/sop/update`,
    method: 'POST',
    data,
    baseURL: baseFinanceURL
  });
};

/**
 * SOP -文档版本历史
 */
export const sopVersionHistory = (data) => {
  return request({
    url: `/sop/version/history/${data.documentId}`,
    method: 'POST',
    data,
    baseURL: baseFinanceURL
  });
};

/**
 * SOP -下载、预览
 */
export const sopViewDownload = (data) => {
  return request({
    url: `/sop/document/version/detail`,
    method: 'POST',
    data,
    baseURL: baseFinanceURL
  });
};

